import React from "react";
import Sidebar from "../../../components/Sidebar";
import { AppBar } from "@mui/material";
import QuizSuccess from "./quiz"
const QuizCompletion = () => {
  return (
    <div className="w-full">
      <Sidebar/>
      <AppBar
        color="default"
        className="bg-white shadow-md"
        position="relative"
        sx={{
          width: { sm: `calc(100% - ${240}px)` },
          ml: { sm: `240px` },
        }}
      >
        <QuizSuccess/>
      </AppBar>
    </div>
  );
};
export default QuizCompletion;
